import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Alert
} from '@mui/material';
import { Warning } from '@mui/icons-material';

const DisclaimerModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const hasSeenDisclaimer = localStorage.getItem('visaforge_disclaimer_seen');
    if (!hasSeenDisclaimer) {
      setOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('visaforge_disclaimer_seen', 'true');
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
      disableEscapeKeyDown
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Warning color="warning" />
        Important Legal Disclaimer
      </DialogTitle>
      
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 3 }}>
          This platform is for informational purposes only and does not constitute legal advice.
        </Alert>
        
        <Box sx={{ space: 2 }}>
          <Typography variant="body1" paragraph>
            <strong>VisaForge</strong> is an immigration assessment and form-filling assistance platform. 
            By using this service, you acknowledge and agree to the following:
          </Typography>

          <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 2 }}>
            <li>This platform provides general information and automated form assistance only</li>
            <li>We do not provide legal advice or guarantee immigration success</li>
            <li>Immigration laws and policies change frequently - always verify current requirements</li>
            <li>Success probability estimates are based on general criteria and historical data</li>
            <li>You are responsible for verifying all information before submission</li>
            <li>We recommend consulting with qualified immigration professionals</li>
            <li>VisaForge is not responsible for application outcomes or decisions</li>
          </Typography>

          <Typography variant="body2" paragraph>
            <strong>Data Privacy:</strong> Your personal information is encrypted and stored securely. 
            We do not share your data with third parties without your explicit consent.
          </Typography>

          <Typography variant="body2" paragraph>
            <strong>No Guarantees:</strong> Immigration applications involve complex legal processes. 
            While we strive for accuracy, we cannot guarantee approval or processing times.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button 
          variant="contained" 
          onClick={handleAccept}
          fullWidth
          size="large"
        >
          I Understand and Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DisclaimerModal;